<div mat-dialog-title>
  แก้ไขเวลาเปิดเจอคิว
</div>
<mat-dialog-content class="mat-typography">
  <mat-selection-list dense (selectionChange)="selectionChange($event.option)">
    <mat-divider></mat-divider>
    <ng-container *ngFor="let slot of checkSlots; let i=index;">
      <mat-list-option
        color="primary"
        checkboxPosition="before"
        [value]="slot"
        [(selected)]="slot.check">
        <span>{{ formatSlot(slot) }}</span>
      </mat-list-option>
    </ng-container>
  </mat-selection-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>ยกเลิก</button>
  <button mat-raised-button class="submit-button" [mat-dialog-close]="slots" cdkFocusInitial>บันทึก</button>
</mat-dialog-actions>
